export default __webpack_public_path__ + "static/media/filter.da20fcfd.svg";